export default "__VITE_ASSET__B9q0Hhg8__"